/**
 *
 * @param {el} el
 * @returns totalOffsetTop
 * Total of offsetTop of all offsetParents, to relate element position to global scroll position regardless positioned ancestors.
 */

export default function totalOffsetTop(el) {
  if (el.offsetParent === document.body) return el.offsetTop;

  return el.offsetTop + totalOffsetTop(el.offsetParent);
}
